import { Col, Row } from "react-bootstrap";
import { sanitizeHTML } from "../../../utils/portfolioUtils";
import "../../../css/Resume.css";

const EducationItem = ({ edu }) => {
  return (
    <div className="education-item">
      <Row className="align-items-start">
        <Col md={3}>
          <p className="education-dates mb-0">
            {new Date(edu.start_date).getFullYear()} –{" "}
            {edu.end_date ? new Date(edu.end_date).getFullYear() : "Present"}
          </p>
          {edu.gpa && <span className="gpa-text">GPA: {edu.gpa}</span>}
        </Col>
        <Col>
          <p className="mb-1">
            <strong>{edu.degree}</strong>
          </p>
          <p className="institution-text mb-0">{edu.institution}</p>
          {edu.courses && (
            <div className="courses-section mt-2">
              <strong className="courses-label">Relevant Courses</strong>
              <div
                className="courses-pills"
                dangerouslySetInnerHTML={{ __html: sanitizeHTML(edu.courses) }}
              />
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EducationItem;
